import { render } from "./ApplicationHistoryView.vue?vue&type=template&id=47b59945"
import script from "./ApplicationHistoryView.vue?vue&type=script&lang=js"
export * from "./ApplicationHistoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__